/* =============================================================================
   ALL-DAY BUFFET LANDER — page behaviour (assets/adb-lander.js in the theme)
   Gallery · review slider · carousels · drawers · buy box (size, quantity,
   subscribe / one-time, frequency, prices) · add to cart · phone sticky bar
   · smooth scroll · motion. Built from the lander editor's page script, without
   the editor parts; add to cart is the real one.
   ============================================================================= */
(function () {
  var root = document.getElementById('adb');
  if (!root) return;
  var html = document.documentElement;
  html.classList.add('adb-js');
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function motionOn() { return !reduce && root.getAttribute('data-motion') !== 'off'; }
  function editing() { return html.classList.contains('adb-editing') || html.classList.contains('adb-swapping'); }
  function money(p) { return '£' + (p / 100).toFixed(2); }

  /* ---------- gallery ---------- */
  var track = document.getElementById('adbGalTrack');
  var slides = track ? track.querySelectorAll('.adb-gal__slide') : [];
  var bar = root.querySelector('.adb-gal__bar');
  var thumbs = root.querySelectorAll('.adb-gal__thumbs button');
  var cur = 0;
  if (bar) bar.style.setProperty('--n', slides.length);
  function syncThumbs() {
    root.querySelectorAll('img[data-thumb-of]').forEach(function (t) {
      var src = root.querySelector('img[data-slot="' + t.getAttribute('data-thumb-of') + '"]');
      if (!src) return;
      if (t.src !== src.src) t.src = src.src;
      t.style.objectPosition = src.style.objectPosition;
    });
  }
  var galEl = root.querySelector('.adb-gal');
  function mark(i) {
    cur = i;
    if (galEl) galEl.setAttribute('data-at', i);
    if (bar) bar.style.setProperty('--i', i);
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
  }
  function go(i) {
    i = (i + slides.length) % slides.length;
    track.scrollTo({ left: i * track.clientWidth, behavior: motionOn() ? 'smooth' : 'auto' });
    mark(i);
  }
  if (track) {
    var st;
    track.addEventListener('scroll', function () {
      clearTimeout(st);
      st = setTimeout(function () { mark(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    }, { passive: true });
    root.querySelectorAll('[data-gal]').forEach(function (b) {
      b.addEventListener('click', function () { go(cur + (+b.getAttribute('data-gal'))); });
    });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(+t.getAttribute('data-i')); }); });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(cur + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(cur - 1); }
    });
    syncThumbs();
    mark(0);
  }

  /* ---------- the science: one tab per problem ---------- */
  var sciTabs = Array.prototype.slice.call(root.querySelectorAll('[data-sci-tab]'));
  function sciShow(name, focus) {
    sciTabs.forEach(function (t) {
      var on = t.getAttribute('data-sci-tab') === name;
      t.setAttribute('aria-selected', on ? 'true' : 'false'); t.tabIndex = on ? 0 : -1;
      if (on && focus) t.focus();
    });
    root.querySelectorAll('[data-sci-panel]').forEach(function (p) { p.hidden = p.getAttribute('data-sci-panel') !== name; });
  }
  sciTabs.forEach(function (t, i) {
    t.addEventListener('click', function () { sciShow(t.getAttribute('data-sci-tab')); });
    t.addEventListener('keydown', function (e) {
      var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0; if (!d) return;
      e.preventDefault(); var n = sciTabs[(i + d + sciTabs.length) % sciTabs.length]; sciShow(n.getAttribute('data-sci-tab'), true);
    });
  });

  /* ---------- review slider in the buy column ---------- */
  var mini = root.querySelector('.adb-mini__track');
  if (mini) root.querySelectorAll('[data-mini]').forEach(function (b) {
    b.addEventListener('click', function () {
      var n = mini.children.length, w = mini.clientWidth;
      var i = (Math.round(mini.scrollLeft / w) + (+b.getAttribute('data-mini')) + n) % n;
      mini.scrollTo({ left: i * w, behavior: motionOn() ? 'smooth' : 'auto' });
    });
  });

  /* ---------- carousels (reviews, community) ---------- */
  root.querySelectorAll('[data-rail]').forEach(function (b) {
    b.addEventListener('click', function () {
      var sec = b.closest('.adb-sec'), rail = sec && sec.querySelector('.adb-rail');
      if (!rail || !rail.children.length) return;
      var step = rail.children[0].offsetWidth + parseFloat(getComputedStyle(rail).columnGap || 24);   /* layout px: right under the desktop 80% zoom too */
      rail.scrollBy({ left: step * (+b.getAttribute('data-rail')), behavior: motionOn() ? 'smooth' : 'auto' });
    });
  });

  /* ---------- endless carousel (reviews): a copy of the cards either side,
     and when a swipe or an arrow lands in a copy it quietly jumps back to the
     same card in the real set, so it never runs out either way ---------- */
  var LOOPS = [];
  function loopRail(rail) {
    var st = rail.__loop || (rail.__loop = { t: 0 });
    var rel = st.rel || 0;          /* where it was resting, measured from the first real card (moving the section resets scrollLeft) */
    rail.querySelectorAll(':scope > .adb-clone').forEach(function (c) { c.remove(); });
    var real = Array.prototype.filter.call(rail.children, function (c) { return !c.hasAttribute('data-off') && c.getClientRects().length; });
    st.on = real.length > 1;
    if (!st.on) return;
    function copy(c, after) {
      var k = c.cloneNode(true);
      k.classList.add('adb-clone', after ? 'adb-clone--after' : 'adb-clone--before');
      k.classList.remove('adb-fall', 'is-pre', 'is-fall', 'adb-tilt'); k.style.removeProperty('--d');
      k.setAttribute('aria-hidden', 'true'); k.setAttribute('inert', '');
      [k].concat(Array.prototype.slice.call(k.querySelectorAll('*'))).forEach(function (n) {
        ['data-blk', 'data-edit', 'data-slot', 'data-zone', 'id', 'contenteditable'].forEach(function (a) { n.removeAttribute(a); });
      });
      return k;
    }
    var head = real[0];
    real.forEach(function (c) { rail.insertBefore(copy(c, false), head); });
    real.forEach(function (c) { rail.appendChild(copy(c, true)); });
    st.w = function () { var a = rail.querySelector('.adb-clone--after'); return a ? a.offsetLeft - head.offsetLeft : 0; };
    var w0 = st.w(); jump(w0 + (w0 ? ((rel % w0) + w0) % w0 : 0));
    function jump(x) { rail.style.scrollSnapType = 'none'; rail.scrollLeft = x; void rail.offsetWidth; rail.style.removeProperty('scroll-snap-type'); }
    st.wrap = function () {
      if (!st.on) return;
      var w = st.w(); if (!w) return;
      var x = rail.scrollLeft;
      var half = head.offsetWidth / 2;   /* snap points can sit a few px off (the cards are tilted), so allow half a card */
      if (x < w - half) jump(x + w); else if (x >= 2 * w - half) jump(x - w);      /* always come to rest on the real cards */
      st.rel = rail.scrollLeft - w;
    };
    if (!st.bound) {
      st.bound = true;
      rail.addEventListener('scroll', function () { clearTimeout(st.t); st.t = setTimeout(function () { st.wrap && st.wrap(); }, 150); }, { passive: true });
      if ('onscrollend' in window) rail.addEventListener('scrollend', function () { clearTimeout(st.t); st.wrap && st.wrap(); });
    }
  }
  function loopRails() { LOOPS.forEach(loopRail); }
  root.querySelectorAll('.adb-rail[data-loop]').forEach(function (r) { LOOPS.push(r); });

  /* ---------- drawers: Why 14 days? · Ingredients · FAQs ---------- */
  var drawer = document.getElementById('adbDrawer'), lastFocus = null, dTimer;
  function openDrawer(name) {
    if (!drawer) return;
    clearTimeout(dTimer);
    drawer.querySelectorAll('[data-pane]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-pane') === name); });
    try { document.dispatchEvent(new CustomEvent('adb:page', { detail: name })); } catch (e) {}
    var h = drawer.querySelector('[data-pane="' + name + '"] .adb-drawer__h');
    var panel = drawer.querySelector('.adb-drawer__panel');
    drawer.querySelectorAll('.adb-drawer__h').forEach(function (x) { x.removeAttribute('id'); });
    if (h) h.id = 'adbDrawerTitle';
    lastFocus = document.activeElement;
    drawer.hidden = false;
    html.classList.add('adb-drawer-open');
    panel.scrollTop = 0;
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); panel.focus({ preventScroll: true }); }); });
  }
  function closeDrawer() {
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    html.classList.remove('adb-drawer-open');
    try { document.dispatchEvent(new CustomEvent('adb:page', { detail: null })); } catch (e) {}
    dTimer = setTimeout(function () { drawer.hidden = true; }, motionOn() ? 320 : 0);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  root.querySelectorAll('[data-drawer]').forEach(function (b) { b.addEventListener('click', function (e) { if (b.tagName === 'A') e.preventDefault(); openDrawer(b.getAttribute('data-drawer')); }); });
  if (drawer) {
    drawer.querySelectorAll('[data-close]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- Dr Anna: Read more (only when the bio is cut short) ---------- */
  var more = root.querySelector('[data-more]'), vetCard = more && more.closest('.adb-vet__card');
  function checkMore() {
    if (!more || vetCard.classList.contains('is-more')) return;
    more.hidden = !Array.prototype.some.call(vetCard.querySelectorAll('.adb-vet__p'), function (p) { return p.scrollHeight > p.clientHeight + 1; });
  }
  if (more) {
    more.addEventListener('click', function () {
      if (editing()) return;
      var open = !vetCard.classList.contains('is-more');
      vetCard.classList.toggle('is-more', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      more.children[0].hidden = open; more.children[1].hidden = !open;
      if (!open) checkMore();
    });
    window.addEventListener('resize', checkMore);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(checkMore);
    window.addEventListener('load', checkMore);
    checkMore();
  }

  /* ---------- "How much do I need?" opens the site's feeding calculator
     (the theme's feeding-guide-quiz section, added to the page template) ---------- */
  root.querySelectorAll('.js-fgq-open').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (document.querySelector('.js-fgq-section')) return;
      e.preventDefault();
    });
  });

  /* ---------- Supports pills: a slow running row; its second set (the loop's copy)
     follows the first, so words changed in the editor show in both ---------- */
  root.querySelectorAll('.adb-marquee--chips').forEach(function (mq) {
    var sets = mq.querySelectorAll('.adb-marquee__set');
    if (sets.length < 2) return;
    var a = sets[0];
    function copy() {
      var html = Array.prototype.map.call(a.querySelectorAll('li'), function (li) {
        var t = li.querySelector('[data-edit]') || li;
        return '<li><span>' + t.innerHTML + '</span></li>';
      }).join('');
      for (var i = 1; i < sets.length; i++) if (sets[i].innerHTML !== html) sets[i].innerHTML = html;
    }
    copy();
    if (window.MutationObserver) new MutationObserver(copy).observe(a, { subtree: true, childList: true, characterData: true });
  });

  /* ---------- buy box ---------- */
  var form = document.getElementById('adb-buy');
  var idInput = form.querySelector('input[name="id"]');
  var planInput = form.querySelector('input[data-plan], input[name="selling_plan"]');
  planInput.setAttribute('data-plan', '');
  var qtyInput = form.querySelector('input[name="quantity"]');
  var freq = document.getElementById('adbFreq');
  var sizeBtns = form.querySelectorAll('.adb-sizes button');
  var opts = form.querySelectorAll('.adb-plan');
  var radios = form.querySelectorAll('input[name="adb-purchase"]');
  var state = { mode: 'sub' };
  /* daily amount for the price per day: the site's feeding calculator for an adult dog of
     this weight at a healthy weight, neutered and moderately active (70 x kg^0.75 kcal x 1.5,
     at 3.54 kcal a gram); days per bag rounded down, as the calculator does */
  var sizesBox = form.querySelector('.adb-sizes');
  var dogKg = parseFloat(sizesBox && sizesBox.getAttribute('data-dog-kg')) || 15;
  var gramsPerDay = 70 * Math.pow(dogKg, 0.75) * 1.5 / 3.54;

  function selected() { return form.querySelector('.adb-sizes button.is-on'); }
  function qty() { var q = parseInt(qtyInput.value, 10); return isNaN(q) || q < 1 ? 1 : Math.min(q, 10); }
  function weeks() { return (freq.options[freq.selectedIndex].text.match(/\d+/) || ['3'])[0]; }

  function render() {
    var v = selected(), q = qty();
    var price = +v.getAttribute('data-price'), sub = +v.getAttribute('data-sub');
    idInput.value = v.getAttribute('data-variant');
    form.querySelector('[data-price-sub]').textContent = money(sub);
    form.querySelector('[data-price-was]').textContent = money(price);
    form.querySelector('[data-price-otp]').textContent = money(price);
    var atcPrice = form.querySelector('[data-atc-price]'), atcWas = form.querySelector('[data-atc-was]');
    if (state.mode === 'sub') {
      planInput.setAttribute('name', 'selling_plan'); planInput.value = freq.value;
      atcPrice.textContent = money(sub * q); atcWas.textContent = money(price * q); atcWas.hidden = false;
    } else {
      planInput.removeAttribute('name');
      atcPrice.textContent = money(price * q); atcWas.hidden = true;
    }
    /* size cards: each shows what it costs a day for the current purchase option (the note under the button says for which dog) */
    form.setAttribute('data-mode', state.mode);
    sizeBtns.forEach(function (x) {
      var o = +x.getAttribute('data-price'), n = state.mode === 'sub' ? +x.getAttribute('data-sub') : o, kg = parseFloat(x.getAttribute('data-size')) || 1;
      var per = x.querySelector('[data-size-per]'), days = Math.floor(kg * 1000 / gramsPerDay);
      if (per && days > 0) per.textContent = money(Math.round(n / days)) + '/day';
    });
    var meta = v.getAttribute('data-size') + (q > 1 ? ' × ' + q : '') + ' · ' + (state.mode === 'sub' ? 'Subscribe · ' + money(sub * q) : 'One-off · ' + money(price * q));
    /* what they save on the option picked: every Buy now button and the phone sticky bar show it */
    var save = state.mode === 'sub' ? Math.max(0, (price - sub) * q) : 0, total = (state.mode === 'sub' ? sub : price) * q;
    root.querySelectorAll('[data-cta-save]').forEach(function (el) { el.hidden = !save; el.textContent = ' - save ' + money(save); });
    var st = document.querySelector('[data-sticky-total]'); if (st) st.textContent = money(total);
    var ss = document.querySelector('[data-sticky-saving]'); if (ss) ss.textContent = money(save);
    var sv = document.querySelector('[data-sticky-save]'); if (sv) sv.hidden = !save;
    var sm = document.querySelector('[data-sticky-meta]'); if (sm) sm.textContent = meta;
  }
  function pickSize(b) {
    sizeBtns.forEach(function (x) { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b ? 'true' : 'false'); });
    render();
  }
  function pickMode(m) {
    state.mode = m;
    radios.forEach(function (r) { r.checked = r.value === m; });
    opts.forEach(function (o) { o.classList.toggle('is-on', o.getAttribute('data-opt') === m); });
    render();
  }
  /* With one-time purchase picked, the subscribe card stays open with its benefits
     crossed out (as on the product page); a tap anywhere on it switches back. */
  var subCard = form.querySelector('.adb-plan--sub');
  if (subCard) subCard.addEventListener('click', function (e) {
    if (state.mode === 'sub' || editing() || e.target.closest('a, select, input, label')) return;
    pickMode('sub');
  });
  sizeBtns.forEach(function (b) { b.addEventListener('click', function () { pickSize(b); }); });
  form.querySelectorAll('[data-qty]').forEach(function (b) {
    b.addEventListener('click', function () { qtyInput.value = Math.max(1, Math.min(10, qty() + (+b.getAttribute('data-qty')))); render(); });
  });
  qtyInput.addEventListener('change', function () { qtyInput.value = qty(); render(); });
  radios.forEach(function (r) { r.addEventListener('change', function () { pickMode(r.value); }); });
  freq.addEventListener('change', render);

  /* ---------- add to cart ----------
     POST /cart/add.js (variant, quantity and, for subscriptions, the Skio
     selling plan), then open the Rebuy Smart Cart and refresh the header
     count, as the feeding-guide quiz does. No Smart Cart: go to /cart. */
  var toast = document.getElementById('adbToast'), tt;
  function say(msg) { if (!toast) return; toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { toast.classList.remove('is-on'); }, 4200); }
  var atcBtn = document.getElementById('adbAtc'), busy = false;
  function setBusy(on) {
    busy = on;
    [atcBtn, document.querySelector('[data-sticky-add]')].forEach(function (b) { if (b) b.setAttribute('aria-busy', on ? 'true' : 'false'); });
  }
  function addToCart() {
    if (busy) return;
    var v = selected(), item = { id: +v.getAttribute('data-variant'), quantity: qty() };
    if (state.mode === 'sub' && freq.value) item.selling_plan = +freq.value;
    var root_ = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    setBusy(true);
    fetch(root_ + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    }).then(function () {
      setBusy(false);
      try { document.dispatchEvent(new CustomEvent('rebuy:cart.change')); } catch (e) {}
      if (window.Rebuy && Rebuy.SmartCart && typeof Rebuy.SmartCart.show === 'function') Rebuy.SmartCart.show();
      else window.location.href = root_ + 'cart';
    }).catch(function (err) {
      setBusy(false);
      say((err && (err.description || err.message)) || 'Sorry, that didn\u2019t go in your basket. Please try again.');
    });
  }
  form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });

  /* ---------- smooth scroll for in-page links ---------- */
  /* The site header slides away while you scroll down and comes back when you
     scroll up, so on a phone only leave room for it when the jump goes up. */
  var siteHdr = document.querySelector('.main-header-section');
  function scrollToEl(t) {
    var top = t.getBoundingClientRect().top + window.pageYOffset, off;
    if (window.innerWidth < 900) {
      var up = top < window.pageYOffset, annc = siteHdr && siteHdr.querySelector('.header-top');
      off = up && siteHdr ? siteHdr.offsetHeight - (annc ? annc.offsetHeight : 0) + 12 : 12;
    } else off = t.id === 'adb-buy' ? 150 : 110;
    window.scrollTo({ top: Math.max(0, top - off), behavior: motionOn() ? 'smooth' : 'auto' });
  }
  root.querySelectorAll('a[data-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      if (editing()) return;
      var t = document.querySelector(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      e.stopImmediatePropagation();      /* the theme's own #-link scroller (app.min.js) would take over and land 50px short */
      scrollToEl(t);
    });
  });

  /* ---------- phone sticky bar: after the hero, subtotal + saving + Buy now (scrolls to the buy box until it is passed, then adds to cart) ---------- */
  var sticky = document.getElementById('adbSticky'), heroCta = root.querySelector('.adb-hero__cta');
  var stickyBtn = sticky && sticky.querySelector('[data-sticky-add]');
  var ticking = false, stickyMode = 'shop';
  function checkSticky() {
    ticking = false;
    if (!sticky) return;
    var vh = window.innerHeight;
    var pastHero = heroCta.getBoundingClientRect().bottom < 0;
    var f = form.getBoundingClientRect();
    var formInView = f.top < vh && f.bottom > 0;
    var on = pastHero && !formInView;
    var mode = f.bottom <= 0 ? 'add' : 'shop';
    stickyMode = mode;   /* Buy now: scrolls up to the buy box until they've passed it, then adds to cart */
    if (on === sticky.classList.contains('is-on')) return;
    sticky.classList.toggle('is-on', on);
    sticky.setAttribute('aria-hidden', on ? 'false' : 'true');
    stickyBtn.tabIndex = on ? 0 : -1;
  }
  if (sticky && heroCta) {
    stickyBtn.addEventListener('click', function () {
      if (html.classList.contains('adb-editing')) return;
      if (stickyMode === 'add') addToCart(); else scrollToEl(form);
    });
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(checkSticky); } }, { passive: true });
    window.addEventListener('resize', checkSticky);
    checkSticky();
  }

  /* ---------- motion: cards fall into place, photos tilt into place ---------- */
  var io = null;
  function arm() {
    if (io) io.disconnect();
    var falls = root.querySelectorAll('.adb-fall'), tilts = root.querySelectorAll('.adb-tilt');
    falls.forEach(function (c) { c.classList.remove('is-fall', 'is-pre'); c.style.removeProperty('--d'); });
    tilts.forEach(function (c) { c.classList.remove('is-pre'); c.style.removeProperty('transition-delay'); });
    if (!motionOn() || !('IntersectionObserver' in window)) return;
    void root.offsetWidth;                                   /* restart animations */
    falls.forEach(function (c) { c.classList.add('is-pre'); });
    tilts.forEach(function (c) { c.classList.add('is-pre'); });
    io = new IntersectionObserver(function (en) {
      en.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target; io.unobserve(el);
        var sibs = Array.prototype.filter.call(el.parentNode.children, function (x) { return x.classList.contains(el.classList.contains('adb-fall') ? 'adb-fall' : 'adb-tilt'); });
        var k = Math.max(0, sibs.indexOf(el)) % 6;
        if (el.classList.contains('adb-fall')) {
          el.style.setProperty('--d', 'calc(var(--fall-stagger) * ' + k + ')');
          el.classList.remove('is-pre'); el.classList.add('is-fall');
        } else {
          el.style.transitionDelay = (k * 0.08) + 's';
          el.classList.remove('is-pre');
        }
      });
    }, { rootMargin: '0px 0px -10% 0px' });
    falls.forEach(function (c) { io.observe(c); });
    tilts.forEach(function (c) { io.observe(c); });
  }

  /* ---------- start ---------- */
  var annc = document.querySelector('.main-header-section .header-top');
  if (annc) document.body.classList.add('adb-annc');
  /* Hero photo on phones: it takes whatever height is left once the copy,
     the promise row and Shop now are in, so all of it lands on the first
     screen of the Meta in-app browser and the next section just peeks.
     Measured once per screen size (not while the toolbars slide on scroll). */
  var phoneMQ = window.matchMedia ? matchMedia('(max-width:768px)') : { matches: false };
  var HERO_PEEK = 24, fitW = 0, fitH = 0;
  function fitHero() {
    var ph = root.querySelector('.adb-hero__photo'), hero = root.querySelector('.adb-hero');
    if (!ph || !hero || !phoneMQ.matches || ph.hasAttribute('data-off') || !ph.offsetParent) { root.style.removeProperty('--hero-ph'); return; }
    var top = hero.getBoundingClientRect().top + (window.scrollY || 0);
    var rest = hero.offsetHeight - ph.getBoundingClientRect().height;
    var want = Math.round(window.innerHeight - top - rest - HERO_PEEK);
    want = Math.max(120, Math.min(320, want));
    root.style.setProperty('--hero-ph', want + 'px');
    fitW = window.innerWidth; fitH = window.innerHeight;
  }
  window.addEventListener('resize', function () {
    if (window.innerWidth !== fitW || (!(window.scrollY > 4) && window.innerHeight !== fitH)) fitHero();
  });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitHero);
  window.addEventListener('load', fitHero);
  fitHero();
  loopRails();
  window.addEventListener('load', loopRails);
  arm();
  if (form.hasAttribute('data-no-sub')) pickMode('otp');
  render();
})();
/* ---------------------------------------------------------------------------
   Delivery frequency by size (19 Oct 2026)
   Each size starts on its own delivery frequency: 3kg every 5 weeks, 6kg and
   12kg every 6 weeks. If a shopper picks a frequency themselves, changing size
   keeps their choice. To change the weeks later, edit the numbers on the
   WEEKS line below. Nothing else on the page changes.
   --------------------------------------------------------------------------- */
;(function () {
  var WEEKS = { '3kg': 5, '6kg': 6, '12kg': 6 };
  var form = document.getElementById('adb-buy');
  var freq = document.getElementById('adbFreq');
  if (!form || !freq) return;
  var chosen = false, setting = false;
  function weeksIn(opt) { var m = /every\s+(\d+)\s+week/i.exec(opt.text); return m ? +m[1] : 0; }
  function useSizeDefault() {
    if (chosen) return;
    var on = form.querySelector('.adb-sizes button.is-on');
    var w = on && WEEKS[(on.getAttribute('data-size') || '').toLowerCase().replace(/\s+/g, '')];
    if (!w) return;
    for (var i = 0; i < freq.options.length; i++) {
      if (weeksIn(freq.options[i]) === w) {
        if (freq.selectedIndex !== i) {
          freq.selectedIndex = i;
          setting = true;
          freq.dispatchEvent(new Event('change', { bubbles: true }));   /* the lander's own code then updates the plan and prices */
          setting = false;
        }
        return;
      }
    }
  }
  freq.addEventListener('change', function () { if (!setting) chosen = true; });   /* any change this block didn't make is the shopper's own pick */
  form.querySelectorAll('.adb-sizes button').forEach(function (b) { b.addEventListener('click', useSizeDefault); });
  useSizeDefault();
})();